import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FollowUpStatusService {

  constructor(private ws: PostmethodService) { }

  followupStatusCrud(request: any) {
    return this.ws.wsPost(request, environment.masterUrl + "followupStatusMaster");
  }
}
